const route = {
	name: 'batch-accounting',
	path: 'batch-accounting',
	meta: {
		title: 'Contabilizar por lotes',
	},
	component: () => import('@/pages/accounting-periods/page-batch-accounting'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/batch-accounting.js